// userLayout
import BasicLayout from './layouts/BasicLayout';
import MobileLayout from './layouts/MobileLayout';
import UserLayout from './layouts/UserLayout';
import MobileCheckin from './pages/_Mobile/MobileCheckin';
import MobileHome from './pages/_Mobile/MobileHome';
import MobileNoticeRecord from './pages/_Mobile/MobileNoticeRecord';
import MobilePersonalNotice from './pages/_Mobile/MobilePersonalNotice';
import MobileSetting from './pages/_Mobile/MobileSetting';
import MobileSystemSetting from './pages/_Mobile/MobileSystemSetting';
import AccountAccessSetting from './pages/AccountAccessSetting';
import AccountAuthSetting from './pages/AccountAuthSetting';
import Accounting from './pages/Accounting';
import AccountingFrontDesk from './pages/AccountingFrontDesk';
import AccountList from './pages/AccountList';
import AccountPageSetting from './pages/AccountPageSetting';
import AdminAuthSetting from './pages/AdminAuthSetting';
import Announcement from './pages/Announcement';
import AnnouncementFrontDesk from './pages/AnnouncementFrontDesk';
import BA from './pages/BA';
import BADevice from './pages/BADevice';
import BAFrontDesk from './pages/BAFrontDesk';
import Broadcast from './pages/Broadcast';
import BroadcastAdd from './pages/BroadcastAdd';
import BroadcastBox from './pages/BroadcastBox';
import BroadcastFrontDesk from './pages/BroadcastFrontDesk';
import BroadcastGroup from './pages/BroadcastGroup';
import BroadcastUrgent from './pages/BroadcastUrgent';
import Calendar from './pages/Calendar';
import CalendarFrontDesk from './pages/CalendarFrontDesk';
import CameraFontDesk from './pages/CameraFontDesk';
import CardManagement from './pages/CardManagement';
import CarLicense from './pages/CarLicense';
import CarLicenseFrontDesk from './pages/CarLicenseFrontDesk';
import CarServiceArrangement from './pages/CarServiceArrangement';
import CarServiceToday from './pages/CarServiceToday';
import ChargingPileExpenseList from './pages/ChargingPile/ChargingPileExpenseList';
import ChargingPileGroupManagement from './pages/ChargingPile/ChargingPileGroupManagement';
import ChargingPileManagement from './pages/ChargingPile/ChargingPileManagement';
import ChargingPileSetting from './pages/ChargingPile/ChargingPileSetting';
import EnergyFrontDesk from './pages/ChargingPile/EnergyFrontDesk';
import Monitor from './pages/ChargingPile/Monitor';
import Clean from './pages/Clean';
import CleanAppointmentRecord from './pages/CleanAppointmentRecord';
import CleanFrontDesk from './pages/CleanFrontDesk';
import CleanKindManagement from './pages/CleanKindManagement';
import CollectingMemberInfoSetting from './pages/CollectingMemberInfoSetting';
import CommunityDevice from './pages/CommunityDevice';
import CommunityFiles from './pages/CommunityFiles';
import CommunityFrontDeskStyle from './pages/CommunityFrontDeskStyle';
import CommunityInformation from './pages/CommunityInformation';
import CommunityInformationManagement from './pages/CommunityInformationManagement';
import CommunityRules from './pages/CommunityRules';
import CommunityRulesFrontDesk from './pages/CommunityRulesFrontDesk';
import DeliveryFrontDesk from './pages/Delivery/DeliveryFrontDesk';
import DeliveryList from './pages/Delivery/DeliveryList';
import DeliveryListHistory from './pages/Delivery/DeliveryListHistory';
import DepositFrontDesk from './pages/DepositFrontDesk';
import DepositReceive from './pages/DepositReceive';
import DepositRegistration from './pages/DepositRegistration';
import EdutainmentApplicationManagement from './pages/EdutainmentApplicationManagement';
import EdutainmentCategoryManagement from './pages/EdutainmentCategoryManagement';
import EdutainmentCheckIn from './pages/EdutainmentCheckIn';
import EdutainmentOrderManagement from './pages/EdutainmentOrderManagement';
import EdutainmentSchedule from './pages/EdutainmentSchedule';
import EdutainmentVenueManagement from './pages/EdutainmentVenueManagement';
import ElevatorFrontDesk from './pages/ElevatorFrontDesk';
import ElevatorService from './pages/ElevatorService';
import ElevatorServiceFrontDesk from './pages/ElevatorServiceFrontDesk';
import EquipmentInspection from './pages/EquipmentInspection';
import FeatureGuide from './pages/FeatureGuide';
import Feedback from './pages/Feedback';
import FeedbackFrontDesk from './pages/FeedbackFrontDesk';
import FeedbackSchedule from './pages/FeedbackSchedule';
import FinanceCommunity from './pages/Finance/FinanceCommunity/index';
import FinanceSetting from './pages/Finance/FinanceSetting/index';
import Finance from './pages/Finance/PersonalFinance/index';
import Fix from './pages/Fix';
import FixFrontDesk from './pages/FixFrontDesk';
import Food from './pages/Food';
import Gas from './pages/Gas';
import GasFrontDesk from './pages/GasFrontDesk';
import GroupBuyingOrderManagement from './pages/GroupBuyingOrderManagement';
import GroupBuyingSettingAndManagement from './pages/GroupBuyingSettingAndManagement';
import GuestFace from './pages/GuestFace';
import GuestFaceFrontDesk from './pages/GuestFaceFrontDesk';
import Health from './pages/Health';
import HealthFrontDesk from './pages/HealthFrontDesk';
import Home from './pages/Home';
import HouseholdPoints from './pages/HouseholdPoints';
import InstructorsManagement from './pages/InstructorsManagement';
import LeaseManagement from './pages/LeaseManagement';
import LifeServiceFrontDesk from './pages/LifeServiceFrontDesk';
import LockerHistoryPage from './pages/LockerHistory';
import LockerManagement from './pages/LockerManagement';
import Login from './pages/Login';
import LongRepairPlan from './pages/LongRepairPlan';
import MachineInspect from './pages/MachineInspect';
import MachineInspectFrontDesk from './pages/MachineInspectFrontDesk';
import MaintainPlan from './pages/MaintainPlan';
import Maintenance from './pages/Maintenance';
import MemberAuthSetting from './pages/MemberAuthSetting';
import MemberFreezeManagement from './pages/MemberFreezeManagement';
import MemberInfoSetting from './pages/MemberInfoSetting';
import MemberPointManagement from './pages/MemberPointManagement';
import MessageList from './pages/MessageList';
import NoticeRecord from './pages/NoticeRecord';
import Organization from './pages/Organization';
import AbsenceRecord from './pages/Organization/components/AbsenceRecord';
import CommitteeTransfer from './pages/Organization/components/CommitteeTransfer';
import ManagementCommittee from './pages/Organization/components/ManagementCommittee';
import Personnel from './pages/Organization/components/Personnel';
import Property from './pages/Organization/components/Property';
import Vendor from './pages/Organization/components/Vendor';
import OutsourcedVendorsManagement from './pages/OutsourcedVendorsManagement';
import ParkingSpaceList from './pages/ParkingSpaceList';
import Patrol from './pages/Patrol';
import PatrolFrontDesk from './pages/PatrolFrontDesk';
import PayFrontDesk from './pages/PayFrontDesk';
import PayList from './pages/PayList';
import Person from './pages/Person';
import PointManagement from './pages/PointManagement';
import PointManagementFrontDesk from './pages/PointManagementFrontDesk';
import PostalFrontDesk from './pages/PostalFrontDesk';
import PostalRegistration from './pages/PostalRegistration';
import PostalReturn from './pages/PostalReturn';
import PostalServiceReceive from './pages/PostalServiceReceive';
import PostalserviceSearch from './pages/PostalserviceSearch';
import PreservationFrontDesk from './pages/PreservationFrontDesk';
import PublicAppointmentFrontDesk from './pages/PublicAppointmentFrontDesk';
import PublicAppointmentHistory from './pages/PublicAppointmentHistory';
import PublicAppointmentHomepage from './pages/PublicAppointmentHomepage';
import PublicInformationCreation from './pages/PublicInformationCreation';
import {
  CompanyRating,
  QuestionnaireList,
  QuestionnaireStatistics,
} from './pages/Questionnaire/Desktop';
import MobileQuestionnaireList from './pages/Questionnaire/Mobile/MobileQuestionnaireList';
import Register from './pages/Register';
import Reminder from './pages/Reminder';
import RepairPlan from './pages/RepairPlan';
import RepairBudget from './pages/RepairUrgent';
import ResetPasswordVerify from './pages/ResetPasswordVerify';
import ResidentAccountNumbers from './pages/ResidentAccountNumbers';
import ResidentBaAuth from './pages/ResidentBaAuth';
import ResidentBuilding from './pages/ResidentBuilding';
import ResidentEmit from './pages/ResidentEmit';
import ResidentScanType from './pages/ResidentScanType';
import SmartBuilding from './pages/SmartBuilding';
import SmartCommunityFiles from './pages/SmartBuilding/CommunityFiles';
import SmartBuildingAsset from './pages/SmartBuildingAsset';
import SmartBuildingBaIntegrate from './pages/SmartBuildingBaIntegrate';
import SmartBuildingCollection from './pages/SmartBuildingCollection';
import SmartBuildingFrontDesk from './pages/SmartBuildingFrontDesk';
import SmartEffectiveness from './pages/SmartEffectiveness';
import SmartMail from './pages/SmartMail';
import SmartMailFrontDesk from './pages/SmartMailFrontDesk';
import SubscriptionPlanManagement from './pages/SubscriptionPlanManagement';
import SystemSetting from './pages/SystemSetting';
import TicketManagement from './pages/TicketManagement';
import UpdateSystem from './pages/UpdateSystem';
import VisitorAccessAppointmentFrontDesk from './pages/VisitorAccessAppointmentFrontDesk';
import VisitorAccessAppointmentRegistration from './pages/VisitorAccessAppointmentRegistration';
import VisitorAccessCarLicense from './pages/VisitorAccessCarLicense';
import VisitorAccessDiscern from './pages/VisitorAccessDiscern';
import VisitorAccessStatistics from './pages/VisitorAccessStatistics';
import VisitorAppointmentFrontDesk from './pages/VisitorAppointmentFrontDesk';
import VisitorAppointmentRegistration from './pages/VisitorAppointmentRegistration';
import VisitorStatistics from './pages/VisitorStatistics';
import Vote from './pages/Vote';
import VoteAdd from './pages/VoteAdd';
import VoteFrontDesk from './pages/VoteFrontDesk';

const routerConfig = [
  {
    path: '/mobile',
    component: MobileLayout,
    children: [
      {
        path: '/home',
        component: MobileHome,
      },
      {
        path: '/setting',
        component: MobileSetting,
      },
      {
        path: '/personalNotice',
        component: MobilePersonalNotice,
      },
      {
        path: '/checkin',
        component: MobileCheckin,
      },
      {
        path: '/noticeRecord',
        component: MobileNoticeRecord,
      },
      {
        path: '/systemSetting',
        component: MobileSystemSetting,
      },
      {
        path: '/user/person',
        component: Person,
      },
      {
        path: '/user/login',
        component: Login,
      },
      {
        path: '/user/register',
        component: Register,
      },
      {
        path: '/user/resetPasswordVerify',
        component: ResetPasswordVerify,
      },
      {
        path: '/announcement/announcementFrontDesk',
        component: AnnouncementFrontDesk,
      },
      {
        path: '/calendar/calendarFrontDesk',
        component: CalendarFrontDesk,
      },
      {
        path: '/postal/postalFrontDesk',
        component: PostalFrontDesk,
      },
      {
        path: '/public/publicAppointmentFrontDesk',
        component: PublicAppointmentFrontDesk,
      },
      {
        path: '/visitor/visitorAppointmentFrontDesk',
        component: VisitorAppointmentFrontDesk,
      },
      {
        path: '/visitorAccess/visitorAccessAppointmentFrontDesk',
        component: VisitorAccessAppointmentFrontDesk,
      },
      {
        path: '/vote/VoteFrontDesk',
        component: VoteFrontDesk,
      },
      {
        path: '/pay/payFrontDesk',
        component: PayFrontDesk,
      },
      {
        path: '/fix/fixFrontDesk',
        component: FixFrontDesk,
      },

      {
        path: '/deposit/depositFrontDesk',
        component: DepositFrontDesk,
      },
      {
        path: '/gas/gasFrontDesk',
        component: GasFrontDesk,
      },
      {
        path: '/feedback/feedbackFrontDesk',
        component: FeedbackFrontDesk,
      },
      {
        path: '/energy/energyFrontDesk',
        component: EnergyFrontDesk,
      },
      {
        path: '/accounting/accountingFrontDesk',
        component: AccountingFrontDesk,
      },
      {
        path: '/carLicense/carLicenseFrontDesk',
        component: CarLicenseFrontDesk,
      },
      {
        path: '/guestFace/guestFaceFrontDesk',
        component: GuestFaceFrontDesk,
      },
      {
        path: '/guestFace/guestFaceFrontDesk',
        component: GuestFaceFrontDesk,
      },
      {
        path: '/smartBuilding/smartBuildingFrontDesk',
        component: SmartBuildingFrontDesk,
      },

      {
        path: '/ba/baFrontDesk',
        component: BAFrontDesk,
      },
      {
        path: '/smartMail/smartMailFrontDesk',
        component: SmartMailFrontDesk,
      },
      {
        path: '/communityRules/rulesFrontDesk',
        component: CommunityRulesFrontDesk,
      },
      {
        path: '/health/healthFrontDesk',
        component: HealthFrontDesk,
      },
      {
        path: '/preservation/preservationFrontDesk',
        component: PreservationFrontDesk,
      },
      {
        path: '/elevator/elevatorFrontDesk',
        component: ElevatorFrontDesk,
      },
      {
        path: '/broadcast/broadcastFrontDesk',
        component: BroadcastFrontDesk,
      },
      {
        path: '/questionnaire/questionnaireFrontDesk',
        component: MobileQuestionnaireList,
      },
      {
        path: '/pointManagement/pointManagementFrontDesk',
        component: PointManagementFrontDesk,
      },
      {
        path: 'machineInspect/machineInspectFrontDesk',
        component: MachineInspectFrontDesk,
      },
      {
        path: '/smartBuilding/collection',
        component: SmartBuildingCollection,
      },
      {
        path: '/delivery/deliveryFrontDesk',
        component: DeliveryFrontDesk,
      },
      {
        path: '/lifeService/lifeServiceFrontDesk',
        component: LifeServiceFrontDesk,
      },
      {
        path: '/featureGuide',
        component: FeatureGuide,
      },
      {
        path: '/reminder/reminderFrontDesk',
        component: Reminder,
      },
      {
        path: '/camera/cameraFrontDesk',
        component: CameraFontDesk,
      },
    ],
  },
  {
    path: '/user',
    component: UserLayout,
    children: [
      {
        path: '/login',
        component: Login,
      },
      {
        path: '/register',
        component: Register,
      },
      {
        path: '/resetPasswordVerify',
        component: ResetPasswordVerify,
      },

      {
        path: '/',
        redirect: '/user/login',
      },
    ],
  },
  {
    path: '/ezpro',
    component: BasicLayout,
    children: [
      {
        path: '/home',
        component: Home,
      },

      {
        path: '/person',
        component: Person,
      },
      {
        path: '/systemSetting',
        component: SystemSetting,
      },
      {
        path: '/updateSystem',
        component: UpdateSystem,
      },
      {
        path: '/noticeRecord',
        component: NoticeRecord,
      },
      {
        path: '/energy/monitor',
        component: Monitor,
      },
      {
        path: '/energy/chargingPileManagement',
        component: ChargingPileManagement,
      },
      {
        path: '/energy/chargingPileGroupManagement',
        component: ChargingPileGroupManagement,
      },
      {
        path: '/energy/chargingPileExpenseList',
        component: ChargingPileExpenseList,
      },
      {
        path: '/energy/chargingPileSetting',
        component: ChargingPileSetting,
      },
      {
        path: '/calendar/calendarList',
        component: Calendar,
      },
      {
        path: '/calendar/calendarFrontDesk',
        component: CalendarFrontDesk,
      },
      {
        path: '/announcement/announcementList',
        component: Announcement,
      },
      {
        path: '/announcement/announcementFrontDesk',
        component: AnnouncementFrontDesk,
      },
      {
        path: '/postal/postalRegistration',
        component: PostalRegistration,
      },
      {
        path: '/postal/postalReceive',
        component: PostalServiceReceive,
      },
      {
        path: '/postal/postalReturn',
        component: PostalReturn,
      },
      {
        path: '/postal/postalSearch',
        component: PostalserviceSearch,
      },
      {
        path: '/postal/postalFrontDesk',
        component: PostalFrontDesk,
      },
      {
        path: '/public/publicInformationCreation',
        component: PublicInformationCreation,
      },

      {
        path: '/public/publicAppointmentHomepage',
        component: PublicAppointmentHomepage,
      },
      {
        path: '/public/publicAppointmentHistory',
        component: PublicAppointmentHistory,
      },
      {
        path: '/public/publicAppointmentFrontDesk',
        component: PublicAppointmentFrontDesk,
      },
      {
        path: '/visitor/visitorAppointmentRegistration',
        component: VisitorAppointmentRegistration,
      },
      {
        path: '/visitor/visitorAppointmentFrontDesk',
        component: VisitorAppointmentFrontDesk,
      },
      {
        path: '/visitor/visitorStatistics',
        component: VisitorStatistics,
      },
      {
        path: '/visitorAccess/visitorAccessAppointmentRegistration',
        component: VisitorAccessAppointmentRegistration,
      },
      {
        path: '/visitorAccess/visitorAccessAppointmentFrontDesk',
        component: VisitorAccessAppointmentFrontDesk,
      },
      {
        path: '/visitorAccess/visitorAccessStatistics',
        component: VisitorAccessStatistics,
      },
      {
        path: '/visitorAccess/visitorAccessCarLicense',
        component: VisitorAccessCarLicense,
      },
      {
        path: '/visitorAccess/visitorAccessDiscern',
        component: VisitorAccessDiscern,
      },
      {
        path: '/visitorAccess/cardManagement',
        component: CardManagement,
      },
      {
        path: '/community/residentBuilding',
        component: ResidentBuilding,
      },
      {
        path: '/community/residentAccountNumbers',
        component: ResidentAccountNumbers,
      },
      {
        path: '/community/parkingSpaceList',
        component: ParkingSpaceList,
      },
      {
        path: '/community/residentScanType',
        component: ResidentScanType,
      },
      {
        path: '/community/householdPoints',
        component: HouseholdPoints,
      },
      {
        path: '/community/basicInformation',
        component: CommunityInformation,
      },
      {
        path: '/communityRules/rulesList',
        component: CommunityRules,
      },
      {
        path: '/communityRules/rulesFrontDesk',
        component: CommunityRulesFrontDesk,
      },
      {
        path: '/communityFiles/filesList',
        component: CommunityFiles,
      },
      {
        path: '/communityDevice/deviceList',
        component: CommunityDevice,
      },
      {
        path: '/account/accountAccessSetting',
        component: AccountAccessSetting,
      },
      {
        path: '/account/accountAuthSetting',
        component: AccountAuthSetting,
      },
      {
        path: '/account/accountPageSetting',
        component: AccountPageSetting,
      },
      {
        path: '/account/accountList',
        component: AccountList,
      },
      {
        path: '/account/adminAuthSetting',
        component: AdminAuthSetting,
      },
      {
        path: '/account/outsourcedVendorsManagement',
        component: OutsourcedVendorsManagement,
      },
      {
        path: '/account/instructorsManagement',
        component: InstructorsManagement,
      },
      {
        path: '/MemberManagement/memberFreezeManagement',
        component: MemberFreezeManagement,
      },
      {
        path: '/memberManagement/communityInformationManagement',
        component: CommunityInformationManagement,
      },
      {
        path: '/vote/voteList',
        component: Vote,
      },
      {
        path: '/vote/voteAdd',
        component: VoteAdd,
      },
      {
        path: '/vote/VoteFrontDesk',
        component: VoteFrontDesk,
      },
      {
        path: '/pay/payList',
        component: PayList,
      },
      {
        path: '/pay/payFrontDesk',
        component: PayFrontDesk,
      },
      {
        path: '/fix/fixList',
        component: Fix,
      },
      {
        path: '/fix/fixFrontDesk',
        component: FixFrontDesk,
      },

      {
        path: '/deposit/depositRegistration',
        component: DepositRegistration,
      },
      {
        path: '/deposit/depositReceive',
        component: DepositReceive,
      },
      {
        path: '/deposit/depositFrontDesk',
        component: DepositFrontDesk,
      },
      {
        path: '/postal/lockerManagement',
        component: LockerManagement,
      },
      {
        path: '/postal/lockerHistory',
        component: LockerHistoryPage,
      },
      {
        path: '/gas/gasList',
        component: Gas,
      },
      {
        path: '/gas/gasFrontDesk',
        component: GasFrontDesk,
      },
      {
        path: '/energy/energyFrontDesk',
        component: EnergyFrontDesk,
      },
      {
        path: '/accounting/accountingList',
        component: Accounting,
      },
      {
        path: '/accounting/accountingFrontDesk',
        component: AccountingFrontDesk,
      },
      {
        path: '/carLicense/carLicenseList',
        component: CarLicense,
      },
      {
        path: '/carLicense/carLicenseFrontDesk',
        component: CarLicenseFrontDesk,
      },
      {
        path: '/carService/carServiceToday',
        component: CarServiceToday,
      },
      {
        path: '/carService/carServiceArrangement',
        component: CarServiceArrangement,
      },
      {
        path: '/guestFace/guestFaceList',
        component: GuestFace,
      },
      {
        path: '/guestFace/guestFaceFrontDesk',
        component: GuestFaceFrontDesk,
      },
      {
        path: '/guestFace/guestFaceFrontDesk',
        component: GuestFaceFrontDesk,
      },
      {
        path: '/smartBuilding/smartBuildingList',
        component: SmartBuilding,
      },
      {
        path: '/smartBuilding/assetManagement',
        component: SmartBuildingAsset,
      },
      {
        path: '/smartBuilding/effectivenessManagement',
        component: SmartEffectiveness,
      },
      {
        path: '/smartBuilding/smartBuildingFrontDesk',
        component: SmartBuildingFrontDesk,
      },
      {
        path: '/smartBuilding/communityFiles',
        component: SmartCommunityFiles,
      },
      {
        path: '/smartBuilding/collection',
        component: SmartBuildingCollection,
      },
      {
        path: '/groupBuying/groupBuyingSettingAndManagement',
        component: GroupBuyingSettingAndManagement,
      },
      {
        path: '/groupBuying/groupBuyingOrderManagement',
        component: GroupBuyingOrderManagement,
      },
      {
        path: '/memberManagement/subscriptionPlanManagement',
        component: SubscriptionPlanManagement,
      },
      {
        path: '/memberManagement/memberInfoSetting',
        component: MemberInfoSetting,
      },
      {
        path: '/clean/cleanList',
        component: Clean,
      },
      {
        path: '/clean/cleanFrontDesk',
        component: CleanFrontDesk,
      },
      {
        path: '/machineInspect/machineInspectList',
        component: MachineInspect,
      },
      {
        path: '/machineInspect/machineInspectFrontDesk',
        component: MachineInspectFrontDesk,
      },
      {
        path: '/patrol/patrolList',
        component: Patrol,
      },
      {
        path: '/patrol/patrolFrontDesk',
        component: PatrolFrontDesk,
      },
      {
        path: '/elevatorService/elevatorServiceList',
        component: ElevatorService,
      },
      {
        path: '/elevatorService/elevatorServiceFrontDesk',
        component: ElevatorServiceFrontDesk,
      },
      {
        path: '/memberManagement/collectingMemberInfoSetting',
        component: CollectingMemberInfoSetting,
      },
      {
        path: '/memberManagement/memberAuthSetting',
        component: MemberAuthSetting,
      },
      {
        path: '/smartMail/smartMailList',
        component: SmartMail,
      },
      {
        path: '/smartMail/smartMailFrontDesk',
        component: SmartMailFrontDesk,
      },
      {
        path: '/smartBuilding/baIntegrate',
        component: SmartBuildingBaIntegrate,
      },
      {
        path: '/community/residentEmit',
        component: ResidentEmit,
      },
      {
        path: '/community/messageList',
        component: MessageList,
      },
      {
        path: '/community/communityFrontDeskStyle',
        component: CommunityFrontDeskStyle,
      },
      {
        path: '/feedback/feedbackList',
        component: Feedback,
      },
      {
        path: '/feedback/feedbackSchedule',
        component: FeedbackSchedule,
      },
      {
        path: '/feedback/feedbackFrontDesk',
        component: FeedbackFrontDesk,
      },
      {
        path: '/ba/baList',
        component: BA,
      },
      {
        path: '/ba/baDevice',
        component: BADevice,
      },
      {
        path: '/ba/residentBaAuth',
        component: ResidentBaAuth,
      },
      {
        path: '/ba/baFrontDesk',
        component: BAFrontDesk,
      },
      {
        path: '/organization/personnel',
        component: Personnel,
      },
      {
        path: '/organization/property',
        component: Property,
      },
      {
        path: '/organization/vendor',
        component: Vendor,
      },
      {
        path: '/organization/absenceRecord',
        component: AbsenceRecord,
      },
      {
        path: '/organization/managementCommittee',
        component: ManagementCommittee,
      },
      {
        path: '/organization/committeeTransfer',
        component: CommitteeTransfer,
      },
      {
        path: '/smartBuilding/organizationManagement',
        component: Organization,
      },
      {
        path: '/smartBuilding/maintenanceManagement',
        component: Maintenance,
      },
      {
        path: '/finance/residentFinanceList',
        component: Finance,
      },
      {
        path: '/finance/communityFinanceList',
        component: FinanceCommunity,
      },
      {
        path: '/finance/financeSetting',
        component: FinanceSetting,
      },
      {
        path: '/health/healthList',
        component: Health,
      },
      {
        path: '/health/healthFrontDesk',
        component: HealthFrontDesk,
      },
      {
        path: '/preservation/preservationFrontDesk',
        component: PreservationFrontDesk,
      },
      {
        path: '/elevator/elevatorFrontDesk',
        component: ElevatorFrontDesk,
      },
      {
        path: '/delivery/deliveryList',
        component: DeliveryList,
      },
      {
        path: '/delivery/deliveryListHistory',
        component: DeliveryListHistory,
      },
      {
        path: '/delivery/deliveryFrontDesk',
        component: DeliveryFrontDesk,
      },
      {
        path: '/delivery/foodList',
        component: Food,
      },
      {
        path: '/broadcast/broadcastAdd',
        component: BroadcastAdd,
      },
      {
        path: '/broadcast/broadcastList',
        component: Broadcast,
      },
      {
        path: '/broadcast/broadcastGroup',
        component: BroadcastGroup,
      },
      {
        path: '/broadcast/broadcastBoxList',
        component: BroadcastBox,
      },
      {
        path: '/broadcast/broadcastUrgent',
        component: BroadcastUrgent,
      },
      {
        path: '/pointManagement/pointManagementList',
        component: PointManagement,
      },
      {
        path: '/questionnaire/questionnaireList',
        component: QuestionnaireList,
      },
      {
        path: '/questionnaire/questionnaireStatistics',
        component: QuestionnaireStatistics,
      },
      {
        path: '/questionnaire/companyRating',
        component: CompanyRating,
      },
      {
        path: '/pointManagement/pointManagementFrontDesk',
        component: PointManagementFrontDesk,
      },
      {
        path: '/repairPlan/repairPlanList',
        component: RepairPlan,
      },
      {
        path: '/maintainPlan/maintainPlanList',
        component: MaintainPlan,
      },
      {
        path: '/pointManagement/pointManagementFrontDesk',
        component: PointManagementFrontDesk,
      },
      {
        path: '/repairBudget/repairBudgetList',
        component: RepairBudget,
      },
      {
        path: '/leaseManagement/leaseManagementList',
        component: LeaseManagement,
      },
      {
        path: '/longRepairPlan/longRepairPlanList',
        component: LongRepairPlan,
      },
      {
        path: '/clean/CleanAppointmentRecord',
        component: CleanAppointmentRecord,
      },
      {
        path: '/clean/cleanKindManagement',
        component: CleanKindManagement,
      },
      {
        path: '/lifeService/lifeServiceFrontDesk',
        component: LifeServiceFrontDesk,
      },
      {
        path: '/reminder/reminderFrontDesk',
        component: Reminder,
      },
      {
        path: '/camera/cameraFrontDesk',
        component: CameraFontDesk,
      },
      {
        path: '/equipmentInspection/equipmentInspectionManagement',
        component: EquipmentInspection,
      },
      {
        path: '/edutainment/edutainmentCategoryManagement',
        component: EdutainmentCategoryManagement,
      },
      {
        path: '/edutainment/edutainmentCheckIn',
        component: EdutainmentCheckIn,
      },
      {
        path: '/edutainment/edutainmentSchedule',
        component: EdutainmentSchedule,
      },
      {
        path: '/edutainment/edutainmentApplicationManagement',
        component: EdutainmentApplicationManagement,
      },
      {
        path: '/edutainment/edutainmentOrderManagement',
        component: EdutainmentOrderManagement,
      },
      {
        path: '/edutainment/edutainmentVenueManagement',
        component: EdutainmentVenueManagement,
      },
      {
        path: '/ticketManagement/ticketRecordList',
        component: TicketManagement,
      },
      {
        path: '/memberPointManagement/pointRecordList',
        component: MemberPointManagement,
      },
      {
        path: '/',
        redirect: '/home',
      },
    ],
  },
];
export default routerConfig;
